import React, { useState, useEffect } from "react";
import { Snackbar, IconButton, Alert, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useGridApiRef } from '@mui/x-data-grid-pro';
import ControlledDataGrid from '../../../components/DataGrid/ControlledDataGrid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { ProgramFilter, ReportFilterBar } from '../ReportFilters';
import moment from "moment";
import axios from "axios";
import { APIURL } from "../../../config";

export default function ClientTerminationReport(props) {
    const defaultGridId = 71;
    const [gridId, setGridId] = useState(props.customReportGridId || defaultGridId);
    const apiRef = useGridApiRef();

    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [reportDetails, setReportDetails] = useState({});
    const [isFavorite, setIsFavorite] = useState(false);
    const [successText, setSuccessText] = useState("");
    const [errorText, setErrorText] = useState("");
    const [selectedProgram, setSelectedProgram] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setIsLoading(true);
        axios
            .get(APIURL + "/jsreport/getAllReports", {
                params: { empID: props.user.emp_id },
            })
            .then((response) => {
                const report = response?.data?.reports.find((ele) => ele.report_name === "Client Termination Report");
                setReportDetails(report);
                setIsFavorite(report ? (report.status === 1 ? true : false) : false);
            });

        axios
            .get(APIURL + "/reports/getClientTermination", {
                params: {
                    com_id: props.user.comp_id,
                    program_id: selectedProgram || undefined,
                },
            })
            .then((response) => {
                setData(response?.data.length !== 0 ? response?.data : []);
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setIsLoading(false);
            });
    };

    const columns = [
        { field: "cus_id", headerName: "Customer ID", hide: true },
        { field: "DDDID", headerName: "DDD ID", width: 70 },
        { field: "cus_name", headerName: "Customer Name", width: 200 },
        { field: "cus_status", headerName: "Customer Status", width: 200 },
        {
            field: "TransferOutDate",
            headerName: "Transfer Out Date",
            width: 170,
            renderCell: (params) => {
                return (
                    <div>{moment(params.value).isValid() ? moment(params.value).utc().format('MM/DD/YYYY') : params.value}</div>
                )
            }
        },
        { field: "TransferOutReason", headerName: "Transfer Out Reason", width: 200 },
    ]

    const rows = data;

    const markFavourite = async (data, type) => {
        const payload = {
            report_id: data?.report_id,
            status: type,
            empID: props.user.emp_id
        };

        axios
            .put(APIURL + "/jsreport/markFavorite", payload)
            .then((response) => {
                if (response?.status === 200 && response?.data?.code === 200) {
                    setSuccessText(response?.data?.status_message || "Favorite Modifed Succesfully");
                } else {
                    setErrorText("Something went wrong");
                }

                fetchData();
            });
    }

    return (
        <div style={{ margin: 0, width: '100%', padding: 10, boxSizing: 'border-box' }}>
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                    <ReportFilterBar onSearch={() => fetchData()}>
                        <ProgramFilter
                            comp_id={props.user.comp_id}
                            value={selectedProgram}
                            onChange={setSelectedProgram}
                        />
                    </ReportFilterBar>
                    <Tooltip title={isFavorite ? "Remove from favorite reports" : "Add to favorite reports"}>
                        <img
                            src={isFavorite ? "./star-solid.svg" : "./star-regular.svg"}
                            alt="barchart"
                            style={{
                                fontFamily: "Lato",
                                width: "1.5rem",
                                height: "1.5rem",
                                cursor: "pointer",
                                margin: 5
                            }}
                            onClick={() => markFavourite(reportDetails, isFavorite ? 0 : 1)}
                        />
                    </Tooltip>
                </div>
                <div style={{ height: 'calc(100vh - 250px)' }}>
                    <ControlledDataGrid
                        gridId={gridId}
                        user={props.user}
                        initialState={{ sorting: { sortModel: [{ field: "TransferOutDate", sort: "desc" }] } }}
                        apiRef={apiRef}
                        getRowId={(row) => row.cus_id}
                        rows={rows}
                        columns={columns}
                        getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 1 ? 'report-row-alternate' : ''
                        }
                        sx={{
                            '& .report-row-alternate .MuiDataGrid-cell, & .report-row-alternate .MuiDataGrid-filler--pinnedLeft': {
                                backgroundColor: '#EAF4FC',
                            },
                            '& .report-row-alternate:hover .MuiDataGrid-cell, & .report-row-alternate:hover .MuiDataGrid-filler--pinnedLeft': {
                                backgroundColor: '#DCEFFC',
                            },
                        }}
                        checkboxSelection={false}
                        disableRowSelectionOnClick
                        loading={isLoading}
                    />
                </div>
            </div>
            <Snackbar
                open={successText !== ""}
                autoHideDuration={30000}
                onClose={() => setSuccessText("")}
            >
                <Alert
                    sx={{ width: "100%" }}
                    severity={"success"}
                    elevation={6}
                    variant="filled"
                >
                    {successText}
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.25 }}
                        onClick={() => setSuccessText("")}
                    >
                        <CloseIcon />
                    </IconButton>
                </Alert>
            </Snackbar>
            <Snackbar
                open={errorText !== ""}
                autoHideDuration={30000}
                onClose={() => setErrorText("")}
            >
                <Alert
                    sx={{ width: "100%" }}
                    severity={"error"}
                    elevation={6}
                    variant="filled"
                >
                    {errorText}
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.25 }}
                        onClick={() => setErrorText("")}
                    >
                        <CloseIcon />
                    </IconButton>
                </Alert>
            </Snackbar>
        </div>
    );
}
